import React from 'react';
import { Modal } from 'antd';

const CenteredModal = ({ isVisible, onUserResponse, message }) => {
  return (
    <Modal
      // title="Title"
      centered
      visible={isVisible}
      onOk={() => onUserResponse(true)}
      onCancel={() => onUserResponse(false)}
      okText="Yes"
      cancelText="Cancel"
    >
      <p>{message}</p>
    </Modal>
  );
}

export default CenteredModal;
